import { Component, OnInit } from '@angular/core';
import { AgentExistingInsuranceAgencyDetailsHandlerComponent } from './agent-existing-insurance-agency-details.handler';
import { AgentService } from '../services/agent.service';

@Component({
  selector: 'sym-agent-existing-insurance-agency-details',
  templateUrl: './agent-existing-insurance-agency-details.component.html',
  styleUrls: ['./agent-existing-insurance-agency-details.component.scss'],
})
export class AgentExistingInsuranceAgencyDetailsComponent
  extends AgentExistingInsuranceAgencyDetailsHandlerComponent
  implements OnInit
{
  constructor(agentService: AgentService) {
    super(agentService);
  }
  ngOnInit(): void {}
}
